import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { HttpService } from '../http.service';
import { formatDate } from '@angular/common'; // Correct import for formatDate

import { ProgressSpinnerMode, ThemePalette } from '@angular/material';

@Component({
  selector: 'app-comp2a-report',
  templateUrl: './comp2a-report.component.html',
  styleUrls: ['./comp2a-report.component.scss']
})
export class Comp2aReportComponent implements OnInit {

  selected_from_date: any = null;
  selected_to_date: any = null;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;
  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'from_date': this.selected_from_date,
      'to_date': this.selected_to_date,
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.copm2Areport(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      console.error(error);
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const excel_file_name = this.document_file['excel_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = excel_file_name;
    downloadLink.click();
  }


  downloadClickedpdf() {
    console.info('aaaa',)
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const pdf_file_name = this.document_file['pdf_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = pdf_file_name;
    downloadLink.click();
  }

  // Function to handle date change event
  changeEvent() {
    // Get selected first date
    const firstDate = new Date(this.selected_from_date);

    // Automatically set the second date to the day after the first date
    const secondDate = new Date(firstDate);
    secondDate.setDate(firstDate.getDate() + 1); // Increment by 1 day

    // Format the second date as 'yyyy-MM-dd' and assign it
    this.selected_to_date = formatDate(secondDate, 'yyyy-MM-dd', 'en-US');
  }

  // Helper function to format the date as 'yyyy-MM-dd'
  formatDate(date: Date, format: string, locale: string): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }


  ngOnInit() {
  }
}
